import React from 'react';

import NavBar from '../../NavBar';

const Home = () => (
  <div>
    <NavBar />
  </div>
);

export default Home;
